import { Alert, styled } from '@mui/material';

export const StyledAlert = styled(Alert)(() => ({
  '& .MuiAlert-message': {
    padding: 0,
  },
  alignItems: 'center',
}));
